import HZTuto from './HZTuto'

export const initDirectives = (app) => {
  app.directive('hz-tuto', HZTuto)
}
